import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer';  
import { getPrincipalMessage } from "../Service/Api"; 
import LazyLoad from 'react-lazyload';
import { useState ,useEffect } from 'react';
const FormerPrincipalMessage = () => {
      useEffect(() => {
        document.title = 'Former Principal Message-  St Peters convent School Faridabad Haryana';  
    }, []); 
    const [data, setData] = useState([]);
useEffect(() => {
 const fetchData = async () => {
   try {
     const msgdata = await getPrincipalMessage();
    const data = msgdata.filter((item) => item.category === "Vice Principal");
    
     setData(data);
   } catch (error) {
     console.error("Error fetching online registration data:", error);
   }  
 };
 fetchData();
}, []);
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
<li>  About Us  </li> 
     <li> Former Principal's Message </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1> Former Principal's Message  </h1>
         </div>
     </div>
     <div className="row">
     {data.length > 0 && (
       <div className="clearfix">
          <LazyLoad> <img 
           src={`https://webapi.entab.info/api/image/${data[0].attachments}`} 
           className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
           alt={data[0].name || 'Image'}
         /></LazyLoad>
         <p><div dangerouslySetInnerHTML={{ __html: data[0].message }} /></p> 
         <p className="name">
           {data[0].name}<span> Former Principal </span>
         </p>
       </div>
     )}

     {data.length === 0  && (
       <div className="clearfix">
          <LazyLoad> <img 
           src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/dummy.jpg" 
           className="img-fluid col-sm-12 col-md-4 float-md-end mb-3 msgimg" 
           alt=""
         /></LazyLoad>
             <p> Dear Students, </p>
             <p> It's Sr. Nancy and some of you might know me as the former Principal at St. Peter’s Convent School. While I recently said goodbye to that official title, I wanted to reach out and say a few things directly to you, my amazing students. </p> 
             <p> Remember, the best part about any school is its students, and you are the absolute best! </p> 
             <p> I know change can be weird, so don't worry the school is still in great hands. Your new Principal, Sr. Sharon Therese, is a fantastic educator who's just as passionate about your success as I am. </p> 
             <p> Here's the most important thing: never stop learning, growing, and reaching for your dreams. School is an amazing adventure, and I encourage you to embrace every challenge and celebrate every victory along the way. </p> 
             <p> Even though I won't be seeing you in the hallways every day, I'll always be cheering you on! Good luck with everything, and keep making the school and your parents proud! </p>
             <p>Warm regards,</p>
             <p className="name">
            Sr. Nancy Elizabeth C.M.C<span> Former Principal  </span>
             </p>
       </div>
     )}
     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default FormerPrincipalMessage
